import { render, staticRenderFns } from "./DocumentosMetaConsultoria.vue?vue&type=template&id=6d85314d"
import script from "./DocumentosMetaConsultoria.vue?vue&type=script&lang=js"
export * from "./DocumentosMetaConsultoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports